import React from 'react'
import { InsightContentSettingType } from 'components/insightContent/types'
import { CountTypeStrings } from 'enums/CountType'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'

import SharedTotalMeasure from '../SharedTotalMeasure'
import Title from './Title'

const CommonTotalMeasure = ({
  detailSetting,
  countType,
  timeUnits,
  forceNotScale
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
  timeUnits?: MetricTimeUnitStrings[]
  forceNotScale?: boolean
}) => (
  <SharedTotalMeasure
    detailSetting={detailSetting}
    countType={countType}
    timeUnits={timeUnits}
    forceNotScale={forceNotScale}
    title={<Title countType={countType} />}
  />
)

export default CommonTotalMeasure
